import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

// Generate a PDF blob from an element id. Returns a Promise<Blob>.
export async function generatePdfBlob(elementId, { scale = 1.5, marginTop = 20 } = {}) {
  const element = document.getElementById(elementId);
  if (!element) throw new Error('Element not found: ' + elementId);

  // Render the element to canvas with optimized settings
  const canvas = await html2canvas(element, { 
    scale, 
    useCORS: true, 
    allowTaint: true,
    backgroundColor: '#ffffff'
  });
  // Use JPEG with 0.92 quality to balance file size and logo clarity
  const imgData = canvas.toDataURL('image/jpeg', 0.92);

  const pdf = new jsPDF('p', 'pt', 'a4');
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  const imgWidth = canvas.width;
  const imgHeight = canvas.height;
  const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
  const imgScaledWidth = imgWidth * ratio;
  const imgScaledHeight = imgHeight * ratio;

  if (imgScaledHeight <= pdfHeight - marginTop) {
    pdf.addImage(imgData, 'JPEG', (pdfWidth - imgScaledWidth) / 2, marginTop, imgScaledWidth, imgScaledHeight);
  } else {
    // Multi-page slice approach
    const pageCanvas = document.createElement('canvas');
    const pageCtx = pageCanvas.getContext('2d');
    pageCanvas.width = imgWidth;
    const pageHeightPx = Math.floor((pdfHeight - marginTop) / ratio);
    let y = 0;
    let first = true;
    while (y < imgHeight) {
      const h = Math.min(pageHeightPx, imgHeight - y);
      pageCanvas.height = h;
      pageCtx.clearRect(0, 0, pageCanvas.width, pageCanvas.height);
      pageCtx.drawImage(canvas, 0, y, imgWidth, h, 0, 0, imgWidth, h);
      const pageData = pageCanvas.toDataURL('image/jpeg', 0.92);
      if (!first) pdf.addPage();
      pdf.addImage(pageData, 'JPEG', (pdfWidth - imgScaledWidth) / 2, marginTop, imgScaledWidth, h * ratio);
      y += h;
      first = false;
    }
  }

  // Return a Blob so caller can preview then trigger download
  const blob = pdf.output('blob');
  return blob;
}

export default generatePdfBlob;
